import { Icon } from 'antd';

export default Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1237562_3avz1op6uu8.js',
});
